import { defineStore } from '#q-app';
import { createPinia, getActivePinia } from 'pinia';
import { deepClone } from 'src/utils/clone-util';

export default defineStore(() => {
    const pinia = createPinia();
    pinia.use(piniaResettableState);
    pinia.use(piniaPreventHydrateState);
    return pinia;
});

function piniaResettableState({ store, options }) {
    const initialState = deepClone(store.$state);
    store.$reset = () => store.$patch(deepClone(initialState));
    store.shouldSkipReset = options.shouldSkipReset === true;
}

function piniaPreventHydrateState({ store, options }) {
    if (options.preventHydrate) {
        store.preventHydrate = options.preventHydrate;
        return;
    }
    store.preventHydrate = [];
}

export function resetAllStores() {
    const states = Object.keys(getActivePinia()?.state.value);
    for (const state of states) {
        const activeStore = getActivePinia()._s.get(state);
        if (activeStore.shouldSkipReset) {
            continue;
        }
        activeStore.$reset();
    }
}
